function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import './jquery_world'; // for custom $.tooltip function
import React, { Component } from 'react';
import Sidebar from './sidebar';
import AlignmentExporter from './alignment_exporter';
import ReportPlugins from 'report_plugins';
import RunSummary from './report/run_summary';
import GraphicalOverview from './report/graphical_overview';
import AlignmentResults from './report/alignment_results';

/**
 * Renders entire report.
 *
 * Composed of Query and Sidebar components.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Report = /*#__PURE__*/function (_Component) {
  function Report(props) {
    var _this;
    _classCallCheck(this, Report);
    _this = _callSuper(this, Report, [props]);
    // Properties below are internal state used to render results in small
    // slices (see updateState).
    _this.state = {
      user_warning: null,
      download_links: [],
      search_id: '',
      seqserv_version: '',
      program: '',
      program_version: '',
      submitted_at: '',
      results: [],
      queries: [],
      querydb: [],
      params: [],
      stats: [],
      alignment_blob_url: '',
      allQueriesLoaded: false,
      cloud_sharing_enabled: false
    };
    _this.prepareAlignmentOfAllHits = _this.prepareAlignmentOfAllHits.bind(_this);
    _this.setStateFromJSON = _this.setStateFromJSON.bind(_this);
    _this.plugins = new ReportPlugins(_this);
    return _this;
  }

  /**
  * Fetch results.
  */
  _inherits(Report, _Component);
  return _createClass(Report, [{
    key: "fetchResults",
    value: function fetchResults() {
      var path = location.pathname + '.json' + location.search;
      this.pollPeriodically(path, this.setStateFromJSON, this.props.showErrorModal);
    }
  }, {
    key: "pollPeriodically",
    value: function pollPeriodically(path, callback, errCallback) {
      var intervals = [200, 400, 800, 1200, 2000, 3000, 5000];
      function poll() {
        fetch(path).then(function (response) {
          // Handle HTTP status codes
          if (!response.ok) throw response;
          return response.text().then(function (data) {
            if (data) {
              data = parseJSON(data);
            }
            ;
            return {
              status: response.status,
              data: data
            };
          });
        }).then(function (_ref) {
          var status = _ref.status,
            data = _ref.data;
          switch (status) {
            case 202:
              var interval;
              if (intervals.length === 1) {
                interval = intervals[0];
              } else {
                interval = intervals.shift();
              }
              setTimeout(poll, interval);
              break;
            case 200:
              callback(data);
              break;
          }
        })["catch"](function (error) {
          if (error.text) {
            error.text().then(function (errData) {
              errData = parseJSON(errData);
              switch (error.status) {
                case 400:
                case 422:
                case 500:
                  errCallback(errData);
                  break;
                default:
                  console.error("Unhandled error:", error.status);
              }
            });
          } else {
            console.error("Network error:", error);
          }
        });
      }
      function parseJSON(str) {
        var parsedJson = str;
        try {
          parsedJson = JSON.parse(str);
        } catch (e) {
          console.error("Error parsing JSON:", e);
        }
        return parsedJson;
      }
      poll();
    }

    /**
    * Calls setState after any required modification to responseJSON.
    */
  }, {
    key: "setStateFromJSON",
    value: function setStateFromJSON(responseJSON) {
      this.lastTimeStamp = Date.now();
      // the callback prepares the download link for all alignments
      if (responseJSON.user_warning == 'LARGE_RESULT') {
        this.setState({
          user_warning: responseJSON.user_warning,
          download_links: responseJSON.download_links
        });
      } else {
        this.setState(responseJSON, this.prepareAlignmentOfAllHits);
      }
    }

    /**
    * Called as soon as the page has loaded and the user sees the loading spinner.
    * We use this opportunity to setup services that make use of delegated events
    * bound to the window, document, or body.
    */
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchResults();
      // This sets up an event handler which enables users to select text from
      // hit header without collapsing the hit.
      this.preventCollapseOnSelection();
      this.toggleTable();
    }

    /**
    * Called after all results have been rendered.
    */
  }, {
    key: "componentFinishedUpdating",
    value: function componentFinishedUpdating() {
      if (this.state.allQueriesLoaded) return;
      this.shouldShowIndex() && this.setupScrollSpy();
      this.setState({
        allQueriesLoaded: true
      });
    }

    /**
    * Returns loading message
    */
  }, {
    key: "loadingJSX",
    value: function loadingJSX() {
      return /*#__PURE__*/_jsx("div", {
        className: "grid grid-cols-6 gap-4",
        children: /*#__PURE__*/_jsxs("div", {
          className: "col-start-1 col-end-7 text-center pt-3",
          children: [/*#__PURE__*/_jsxs("h1", {
            className: "mb-8 text-4xl",
            children: [/*#__PURE__*/_jsx("i", {
              className: "fa fa-cog fa-spin"
            }), "\xA0 BLAST-ing"]
          }), /*#__PURE__*/_jsx("div", {
            className: "mb-5 w-full",
            children: /*#__PURE__*/_jsx("p", {
              className: "m-auto w-full md:w-6/12 text-sm",
              children: "This can take some time depending on the size of your query and database(s). The page will update automatically when BLAST is done."
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "mb-9 text-sm",
            children: "You can bookmark the page and come back to it later or share the link with someone."
          }), /*#__PURE__*/_jsx("p", {
            className: "text-sm",
            children: process.env.targetEnv === 'cloud' && /*#__PURE__*/_jsx("b", {
              children: "If the job takes more than 10 minutes to complete, we will send you an email upon completion."
            })
          })]
        })
      });
    }

    /* eslint-disable */
    /**
    * Return results JSX.
    */
  }, {
    key: "resultsJSX",
    value: function resultsJSX() {
      var _this2 = this;
      return /*#__PURE__*/_jsxs("div", {
        className: "grid grid-cols-1 md:grid-cols-4 gap-4 print:grid-cols-1",
        id: "results",
        children: [/*#__PURE__*/_jsx("div", {
          className: "hidden md:col-span-1 md:block print:hidden",
          children: /*#__PURE__*/_jsx(Sidebar, {
            data: this.state,
            atLeastOneHit: this.atLeastOneHit(),
            shouldShowIndex: this.shouldShowIndex(),
            allQueriesLoaded: this.state.allQueriesLoaded,
            cloudSharingEnabled: this.state.cloud_sharing_enabled
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "col-span-1 md:col-span-3 print:col-span-1",
          children: [/*#__PURE__*/_jsx(RunSummary, {
            seqserv_version: this.state.seqserv_version,
            program_version: this.state.program_version,
            submitted_at: this.state.submitted_at,
            querydb: this.state.querydb,
            stats: this.state.stats,
            params: this.state.params
          }), /*#__PURE__*/_jsx(GraphicalOverview, {
            queries: this.state.queries,
            prorgam: this.state.program,
            plugins: this.plugins
          }), /*#__PURE__*/_jsx(AlignmentResults, _objectSpread({
            state: this.state,
            populate_hsp_array: this.populate_hsp_array.bind(this),
            componentFinishedUpdating: function componentFinishedUpdating(_) {
              return _this2.componentFinishedUpdating(_);
            },
            plugins: this.plugins
          }, this.props))]
        })]
      });
    }
    /* eslint-enable */
  }, {
    key: "warningJSX",
    value: function warningJSX() {
      return /*#__PURE__*/_jsx("div", {
        className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8",
        children: /*#__PURE__*/_jsx("div", {
          className: "grid grid-cols-6 gap-4",
          children: /*#__PURE__*/_jsxs("div", {
            className: "col-start-1 col-end-7 text-center",
            children: [/*#__PURE__*/_jsxs("h1", {
              className: "mb-4 text-4xl",
              children: [/*#__PURE__*/_jsx("i", {
                className: "fa fa-exclamation-triangle"
              }), "\xA0 Warning"]
            }), /*#__PURE__*/_jsx("p", {
              className: "mb-2",
              children: "The BLAST result might be too large to load in the browser. If you have a powerful machine you can try loading the results anyway. Otherwise, you can download the results and view them locally."
            }), /*#__PURE__*/_jsx("p", {
              className: "mb-2",
              children: this.state.download_links.map(function (link, index) {
                return /*#__PURE__*/_jsx("a", {
                  href: link.url,
                  className: "btn btn-secondary",
                  children: link.name
                }, 'download_link_' + index);
              })
            }), /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx("a", {
                href: location.pathname + '?bypass_file_size_warning=true',
                className: "py-2 px-3 border border-transparent rounded-md shadow-sm text-white bg-seqblue hover:bg-seqorange focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-seqorange",
                children: "View results in browser anyway"
              })
            })]
          })
        })
      });
    }

    // Controller //

    /**
    * Returns true if results have been fetched.
    *
    * A holding message is shown till results are fetched.
    */
  }, {
    key: "isResultAvailable",
    value: function isResultAvailable() {
      return this.state.queries.length >= 1;
    }

    /**
     * Indicates the response contains a warning message for the user
     * in which case we should not render the results and render the
     * warning instead.
     **/
  }, {
    key: "isUserWarningPresent",
    value: function isUserWarningPresent() {
      return this.state.user_warning;
    }

    /**
    * Returns true if we have at least one hit.
    */
  }, {
    key: "atLeastOneHit",
    value: function atLeastOneHit() {
      return this.state.queries.some(function (query) {
        return query.hits.length > 0;
      });
    }

    /**
    * Returns true if index should be shown in the sidebar. Index is shown
    * only for 2 and 8 queries.
    */
  }, {
    key: "shouldShowIndex",
    value: function shouldShowIndex() {
      var num_queries = this.state.queries.length;
      return num_queries >= 2 && num_queries <= 12;
    }

    /**
    * Prevents folding of hits during text-selection.
    */
  }, {
    key: "preventCollapseOnSelection",
    value: function preventCollapseOnSelection() {
      $('body').on('mousedown', '.hit > .section-header > h4', function (event) {
        var $this = $(this);
        $this.on('mouseup mousemove', function handler(event) {
          if (event.type === 'mouseup') {
            // user wants to toggle
            var hitID = $this.parents('.hit').attr('id');
            $("div[data-parent-hit=".concat(hitID, "]")).toggle();
            $this.find('i').toggleClass('fa-square-minus fa-square-plus');
            $($this.data('parent-id')).toggleClass('print:hidden');
          } else {
            // user wants to select
            $this.attr('data-toggle', '');
          }
          $this.off('mouseup mousemove', handler);
        });
      });
    }

    /* Handling the fa icon when Hit Table is collapsed */
    /* TODO:JOKO check if this method still being used? */
  }, {
    key: "toggleTable",
    value: function toggleTable() {
      $('body').on('mousedown', '.resultn .caption[data-toggle="collapse"]', function (event) {
        var $this = $(this);
        $this.on('mouseup mousemove', function handler(event) {
          $this.find('i').toggleClass('fa-square-minus fa-square-plus');
          $this.off('mouseup mousemove', handler);
        });
      });
    }

    /**
    * For the query in viewport, highlights corresponding entry in the index.
    */
  }, {
    key: "setupScrollSpy",
    value: function setupScrollSpy() {
      var sectionIds = $('a.side-nav');
      $(document).scroll(function () {
        sectionIds.each(function () {
          var container = $(this).attr('href');
          var containerOffset = $(container).offset().top;
          var containerHeight = $(container).outerHeight();
          var containerBottom = containerOffset + containerHeight;
          var scrollPosition = $(document).scrollTop();
          if (scrollPosition < containerBottom - 20 && scrollPosition >= containerOffset - 20) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        });
      });
    }
  }, {
    key: "populate_hsp_array",
    value: function populate_hsp_array(hit, query_id) {
      return hit.hsps.map(function (hsp) {
        return Object.assign(hsp, {
          hit_id: hit.id,
          query_id: query_id
        });
      });
    }
  }, {
    key: "prepareAlignmentOfAllHits",
    value: function prepareAlignmentOfAllHits() {
      var _this3 = this;
      // Get number of hits and array of all hsps.
      var num_hits = 0;
      var hsps_arr = [];
      if (!this.state.queries.length) {
        return;
      }
      this.state.queries.forEach(function (query) {
        return query.hits.forEach(function (hit) {
          num_hits++;
          hsps_arr = hsps_arr.concat(_this3.populate_hsp_array(hit, query.id));
        });
      });
      var aln_exporter = new AlignmentExporter();
      var file_name = "alignment-".concat(num_hits, "_hits.txt");
      var blob_url = aln_exporter.prepare_alignments_for_export(hsps_arr, file_name);
      $('.download-alignment-of-all').attr('href', blob_url).attr('download', file_name);
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      if (this.isUserWarningPresent()) {
        return this.warningJSX();
      } else if (this.isResultAvailable()) {
        return this.resultsJSX();
      } else {
        return this.loadingJSX();
      }
    }
  }]);
}(Component);
export default Report;